import { render, staticRenderFns } from "./SmarthomeHeader.vue?vue&type=template&id=2c2b6b3d"
import script from "./SmarthomeHeader.vue?vue&type=script&lang=js"
export * from "./SmarthomeHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports